<template>
  <div class="grid">
    <form class="search-field" @submit="handleSubmit">
      <input 
        :value="page.query || ''" 
        type="text" 
        name="search" 
        class="pill"
        placeholder="Search" 
        autocomplete="off"
        spellcheck="false"
        ref="input"
      />
      <input type="submit" value="" class="icon-search-big accent" />
    </form>
    <div class="options pill-hover">
      <router-link v-for="(value, key) in page.results" 
        :class="[
          'pill', 
          { disabled: !value.count }, 
          { active: key === $route.query.type }
        ]" 
        :to="$route.path + `?type=${key}`"
        :key="key"
      >
        {{ value.title }} ({{ value.count }})
      </router-link>
    </div>
    <select v-if="hasQuery && hasResults" class="pill" v-model="active">
      <option
        v-for="(value, key) in page.results"
        :value="$route.path + `?type=${key}`"
        :key="key"
      >{{ value.title }} ({{ value.count }})</option>
    </select>
    <div v-if="hasQuery && hasResults" :class="gridSize">
      <ArchiveThumb v-for="item in qpages" :page="item" :circle="circle" :key="item.url"></ArchiveThumb>
    </div>
    <div v-else-if="hasQuery" class="no-results">No Results</div>
    <Pagination v-if="qpage && qpage.numpages > 1" :count="qpage.numpages"></Pagination>
  </div> 
</template>

<script>
import delve from 'dlv'
import slugify from '@sindresorhus/slugify'
import { mixin } from '@/lib/content-state'
import Pagination from '@/components/Pagination'
import ArchiveThumb from '@/components/ArchiveThumb'

export default {
  name: 'Search',
  components: { Pagination, ArchiveThumb },
  mixins: [ mixin ],
  computed: {
    active: {
      get () { 
        return this.$route.fullPath
      },
      set (value) {
        if (value) this.$router.push(value)
      }
    },
    hasQuery () {
      return delve(this.page, 'query')
    },
    hasResults () {
      if (delve(this.page, 'results')) {
        return Object.values(this.page.results).reduce((a, b) => {
          return a + b.count
        }, 0)
      } else return null
    },
    gridSize () {
      return delve(this.qpage, 'type') === 'post' 
        ? 'grid-auto-sm' 
        : delve(this.qpage, 'type') === 'event'
        ? 'grid-auto-lg'
        : 'grid-auto-md'
    },
    circle () {
      return delve(this.qpage, 'type') !== 'event'
    }
  },
  methods: {
    handleSubmit (e) {
      e.preventDefault()
      if (this.$refs.input.value) {
        this.$router.push({ path: '/search/' + slugify(this.$refs.input.value) })
      } else {
        this.$router.push({ path: '/search' })
      }
    },
    initialSearch () {
      let results = delve(this.page, 'results') || {}
      if (this.hasQuery && !this.$route.query.type) {
        let candidate = Object.values(results).find(result => result.count)
        if (candidate) {
          this.$router.push({ path: '/search/' + slugify(this.page.query), query: { type: candidate.slug } })  
        }
      }
    }
  },
  mounted () {
    this.$refs.input.focus()
  },
  created () {
    this.initialSearch()
  },
  updated () {
    this.initialSearch()
  }
}
</script>

<style scoped>
.grid {
  align-self: flex-start;
}
form { grid-column: 1 / -1 }

.search-field {
  position: relative;
  font: var(--large); 
}

input[type="text"] {
  border-radius: var(--br2);
  font-size: inherit;
  line-height: var(--lh1);
  padding: 0.4rem 2rem 0.6rem 2rem;
  width: 100%;
}

input[type="submit"] {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 1.6em;
  /*border: 1px solid red;*/
  background-size: 60%;
  background-position: 0 50%;
  /*background-image: url();*/
}

select {
  display: none;
  grid-column: 1 / -1;
}

.options {
  display: grid;
  grid-gap: 2rem;
  grid-column: 1 / -1; 
  grid-template-columns: repeat(4, 1fr);
}

.no-results {
  grid-column: 1 / -1;
  text-align: center;
  padding-top: 2rem;
}

/*.accent::after {
content: '';
display: block;
position: absolute;
width: 100%;
height: 100%;
background-color: red;
}*/

@media (max-width: 1000px) {
  .options { display: none }
  select { display: block }
}
</style>